import React, { useEffect, useState } from 'react';
import { MealType } from 'utils/types';
import { RmxArrowBackIcon } from 'cokitchen-icons';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import useDashboardContext from 'contexts/dashboard.context';
import PageText from 'components/base/page-text';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import DeleteModal from 'components/base/delete-modal';
import SearchNav from 'components/search-nav';
import { numberWithCommas } from 'utils/functions';
import FeedCard from 'components/feed-card';

const TrashedMeals = () => {
  const { activeCokitchen } = useDashboardContext();
  const [activeMeal, setActiveMeal] = useState({} as MealType);
  const [showRestoreCategoryModal, setShowRestoreCategoryModal] = useState(false);
  const [mealsList, setMealsList] = useState([] as MealType[]);
  const [selectedItems, setSelectedItems] = useState([] as string[]);

  const [loading, setLoading] = useState(false);
  const restoreMealCategory = () => {
    setShowRestoreCategoryModal(!showRestoreCategoryModal);
  };

  const fetchData = async () => {
    setLoading(true);
    const payload = { type: 'meal', cokitchen_id: activeCokitchen?.id };
    try {
      const res: any = await apiService.post('marketing/get-archived-items', { data: payload });
      const response = res?.data?.data;
      if (response) {
        setMealsList(res?.data?.data.reverse());
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeCokitchen?.id]);

  const handleRestoreClick = async () => {
    const itemIds = selectedItems.length > 0 ? selectedItems : [activeMeal.id];
    const payload = { type: 'meal', item_ids: itemIds };
    try {
      const res: any = await apiService.post('marketing/restore-bulk-items', { data: payload });
      if (res.data) {
        fetchData();
        restoreMealCategory();
        toast(
          <ToastMessage
            type='success'
            message={`Restored ${
              selectedItems.length > 0 ? 'items' : activeMeal?.name
            } successfully `}
          />
        );
        setSelectedItems([]);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    }
  };

  const handleChange = (category: MealType) => {
    //if (singleMeal?.id) setSingleMeal(null);
    const resultExists = selectedItems.find((id) => id === category.id);
    if (resultExists) {
      setSelectedItems(selectedItems.filter((id) => id !== category.id));
    } else {
      setSelectedItems([...selectedItems, category.id]);
    }
  };

  const restoreBrand = () => {
    setShowRestoreCategoryModal(!showRestoreCategoryModal);
  };
  const removeAll = () => {
    setSelectedItems([]);
  };
  const handleSelectAll = () => {
    const allIds: string[] = mealsList?.map((item: any) => item.id);
    setSelectedItems(allIds);
  };
  return (
    <div>
      {loading ? (
        <PageText text='Loading' />
      ) : mealsList.length === 0 ? (
        <PageText text='No meals found' />
      ) : (
        <div className='grid lg:grid-cols-4 grid-cols-3 gap-4'>
          {mealsList.map((meal, index) => (
            <div key={index}>
              <FeedCard
                key={meal.id}
                image={meal?.images && meal.images[0]}
                actions={
                  selectedItems.length === 0 && (
                    <div
                      onClick={() => {
                        setActiveMeal(meal);
                        restoreMealCategory();
                      }}
                      className='bg-white rounded-lg p-1 '>
                      <RestoreIcon className='w-4 h-4' />
                    </div>
                  )
                }
                showCheckBox
                checked={selectedItems.includes(meal.id)}
                onSelect={() => handleChange(meal)}
                className='mb-6'>
                <div className='flex justify-between items-center mt-2'>
                  <div>
                    <p className='text-sm'>{meal.name}</p>
                    <p className='text-xs text-gray-5'>&#8358; {numberWithCommas(meal.amount)}</p>
                  </div>
                  <RmxArrowBackIcon className='transform rotate-180 w-[20px] h-[20px] text-[#B6AFAF]' />
                </div>
              </FeedCard>
            </div>
          ))}
        </div>
      )}
      <DeleteModal
        show={showRestoreCategoryModal}
        type='restore'
        onClose={restoreMealCategory}
        handleDelete={handleRestoreClick}
        title={`Are you sure you want to restore ${
          selectedItems.length > 0 ? 'items' : activeMeal?.name
        } ?`}
        description='This action will restore this meal'
        loading={loading}
      />
      {selectedItems.length > 0 && (
        <SearchNav
          count={selectedItems.length}
          handleSelectAll={handleSelectAll}
          onRestoreClick={restoreBrand}
          onDoneClick={removeAll}
        />
      )}
    </div>
  );
};

export default TrashedMeals;
